import React, { useState } from 'react';
import { FormInput } from '@getro/rombo';
import { Flex, Box } from 'rebass/styled-components';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';

import { DeleteSelectOptionModal } from './deleteSelectOptionModal';

export const ArrayFieldOption = ({ index, push, remove, isEditMode }) => {
  const [isOpenDeleteSelectOptionModal, setIsOpenDeleteSelectOptionModal] = useState(false);

  return (
    <Flex key={`single-select-option-${index}`} alignItems="flex-start" sx={{ gap: '8px' }}>
      <Field name={`options.${index}.label`}>
        {({ field, form }) => {
          const fieldError = form.errors?.options?.[index]?.label;
          const fieldTouched = form.touched?.options?.[index]?.label;

          return (
            <>
              <FormInput
                form={{
                  ...form,
                  errors: { [field.name]: fieldError },
                  touched: { [field.name]: fieldTouched },
                }}
                field={field}
                id={`option-${index}`}
                placeholder="Enter option"
                size="small"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && field.value && field.value.trim()) {
                    e.preventDefault();
                    const currentIndex = index;
                    push({ label: '', id: null });
                    setTimeout(() => {
                      const newInput = document.getElementById(`option-${currentIndex + 1}`);
                      if (newInput) {
                        newInput.focus();
                      }
                    }, 0);
                  }
                }}
              />
            </>
          );
        }}
      </Field>
      <Flex
        mt="8px"
        alignItems="center"
        justifyContent="center"
        flex="0 0 auto"
        sx={{ cursor: 'pointer', color: 'neutral.500', '&:hover': { color: 'neutral.700' } }}
        onClick={(e) => {
          e.stopPropagation();
          if (isEditMode) {
            setIsOpenDeleteSelectOptionModal(true);
          } else {
            remove(index);
          }
        }}
      >
        <Box as={X} width="16px" height="16px" aria-hidden="true" />
      </Flex>
      {isOpenDeleteSelectOptionModal && (
        <DeleteSelectOptionModal
          onCloseModal={() => setIsOpenDeleteSelectOptionModal(false)}
          onDeleteOption={() => {
            remove(index);
            setIsOpenDeleteSelectOptionModal(false);
          }}
          isLoading={false}
        />
      )}
    </Flex>
  );
};

ArrayFieldOption.propTypes = {
  index: PropTypes.number.isRequired,
  push: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
};

ArrayFieldOption.defaultProps = {
  isEditMode: false,
};
